import { Box } from '@mui/material';

const TABLET_WORKBENCH_MEDIA = '@media (min-width: 1180px)';
const WIDE_WORKBENCH_MEDIA = '@media (min-width: 1500px)';

type StatPillProps = {
  label: string;
  value: string;
  darkMode?: boolean;
};

const StatPill = ({ label, value, darkMode = false }: StatPillProps) => (
  <Box
    sx={{
      borderRadius: '999px',
      backgroundColor: darkMode ? 'rgba(243, 247, 255, 0.08)' : 'rgba(9, 19, 36, 0.06)',
      color: darkMode ? '#F3F7FF' : '#10203A',
      padding: '9px 12px',
      minWidth: '96px',
      [TABLET_WORKBENCH_MEDIA]: {
        padding: '7px 10px',
        minWidth: '88px',
      },
      [WIDE_WORKBENCH_MEDIA]: {
        padding: '9px 12px',
        minWidth: '96px',
      },
    }}
  >
    <Box
      sx={{
        fontSize: '10px',
        fontWeight: 800,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: darkMode ? 'rgba(243, 247, 255, 0.56)' : 'rgba(16, 32, 58, 0.52)',
      }}
    >
      {label}
    </Box>
    <Box
      sx={{
        fontSize: '16px',
        fontWeight: 700,
        marginTop: '2px',
      }}
    >
      {value}
    </Box>
  </Box>
);

export default StatPill;
